import { render } from "./IncomeExpenditureComponent.vue?vue&type=template&id=8acf5632"
import script from "./IncomeExpenditureComponent.vue?vue&type=script&lang=js"
export * from "./IncomeExpenditureComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__